export default "__VITE_ASSET__xuo05B$5__"